import Pixall from './pixall';
export default Pixall;